export const buildYearOptions = <T extends { id: string; name: string }>(
	start = 1900,
	end = new Date().getFullYear()
): Array<T> => {
	const arr: Array<T> = [];
	for (let y = end; y >= start; y -= 1) {
		const s = String(y);
		arr.push({ id: s, name: s } as T);
	}
	return arr;
};
